import { Injectable } from '@angular/core';
import { BaseApi } from './base/base-api';
import { environment } from '../../../environments/environment';
import { map, Observable } from 'rxjs';
import { NwNumberErrorMemory } from '../../../shared/models/nw-number/nw-number-error-memory';
import { ExcludeLanguagesForNwNumberErrorMemory } from '../../../shared/models/nw-number/exclude-languages-for-nw-number-error-memory';

@Injectable({
  providedIn: 'root',
})
export class NwNumberErrorMemoryApiService extends BaseApi {
  constructor() {
    super(environment.api + 'nwnumbererrormemory');
  }

  public getNwNumbersErrorMemory(): Observable<NwNumberErrorMemory[]> {
    return this.http.get<NwNumberErrorMemory[]>(this.baseUrl).pipe(
      map((nws) => {
        nws.forEach((nw) => {
          nw.displayId = nw.number ?? 'n/a';
          nw.extendedDisplayId = `NW Number ${nw.displayId}`;
        });
        return nws;
      })
    );
  }

  public getNwNumberErrorMemoryById(id: string): Observable<NwNumberErrorMemory> {
    return this.http.get<NwNumberErrorMemory>(`${this.baseUrl}/${id}`).pipe(
      map((nw) => {
        nw.displayId = nw.number ?? 'n/a';
        nw.extendedDisplayId = `NW Number ${nw.displayId}`;
        return nw;
      })
    );
  }

  public excludeLanguages(excludeLanguages: ExcludeLanguagesForNwNumberErrorMemory): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/exclude-languages`, excludeLanguages);
  }
}
